import { withStyles } from '@material-ui/core';
import PickupDetails from './PickupDetails';
import MapContainer from './MapContainer';

const styles = (theme) => ({
  container: {
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'column',
    padding: '0 14',
    flex: 'auto'
  }
});

const RoutePreview = ({ classes, mapConfig, ...others }) => {
  return (
    <div className={classes.container}>
      <PickupDetails pickupInfo={others.selectedPickupInfo} />
      <MapContainer {...others} mapConfig={mapConfig} />
    </div>
  );
};

export default withStyles(styles)(RoutePreview);
